export enum YmParam {
  Origin = 'origin',
  Question = 'question',
  Result = 'result',
  Test = 'test',
  Duration = 'duration',
  Answer = 'answer',
}
